<div id="error" class="flex-column">
  <h1>500</h1>
  <h4>Houston, we have a problem!</h4>
  <p>The page you are looking for is temporarily unavailable.</p>
</div>